import {
  DocumentOrganizationKeys,
  FilterDocument,
  FilterDocumentDateCustomTypes,
  FilterDocumentDateFilterTypes,
  FilterOptionKeys,
  GroupByMode,
  SortingMode,
  Timestamp,
} from '@griply/types';
import { subDays } from 'date-fns';

export const COMPLETED_LOOKBACK_DAYS = 14;

export const createDefaultCompletedFilterDocument = (
  today: Timestamp,
): FilterDocument => ({
  [DocumentOrganizationKeys.GroupByMode]: GroupByMode.CompletedDate,
  [DocumentOrganizationKeys.SortingMode]: SortingMode.Custom,
  showCompleted: true,
  [DocumentOrganizationKeys.Filters]: {
    [FilterOptionKeys.CompletedAt]: {
      type: FilterDocumentDateFilterTypes.Custom,
      custom: {
        type: FilterDocumentDateCustomTypes.After,
        start: subDays(today, COMPLETED_LOOKBACK_DAYS),
        end: null,
      },
    },
  },
});
